export var getEmceePath = function getEmceePath() {
  if (window.location.href.includes('emcee')) {
    return window.location.hash.split('#')[1];
  }
};

var sendData = function sendData(level, location, message) {
  var eventData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (window.Sentry) {
    window.Sentry.withScope(function (scope) {
      scope.clear();

      if (eventData.tags) {
        Object.entries(eventData.tags).forEach(function (tags) {
          scope.setTag(tags[0], tags[1]);
        });
      } // To override emcee iframe url


      var pathname = getEmceePath();

      if (pathname) {
        scope.setTag('url', pathname);
      }

      scope.setTag('location', location);
      scope.setExtra('eventData', JSON.stringify(eventData));
      console[level]("".concat(location, ": ").concat(message));
    });
  }
};

var info = function info(location, message, eventData) {
  sendData('info', location, message, eventData);
};

var warn = function warn(location, message, eventData) {
  sendData('warn', location, message, eventData);
};

var error = function error(location, message, eventData) {
  sendData('error', location, message, eventData);
};

export default {
  info: info,
  warn: warn,
  error: error
};